export default __webpack_public_path__ + "static/media/iconSettigs.6ce329ac.svg";